import { render } from "./newLifeZh.vue?vue&type=template&id=55114f0c&scoped=true"
import script from "./newLifeZh.vue?vue&type=script&lang=js"
export * from "./newLifeZh.vue?vue&type=script&lang=js"

import "./newLifeZh.vue?vue&type=style&index=0&id=55114f0c&scoped=true&lang=scss"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55114f0c"]])

export default __exports__